






























import { Component, Prop, Vue } from "vue-property-decorator";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { BButton } from "bootstrap-vue";
import RessifApexPieChart from "../templates/pie-charts/RessifApexPieChart.vue";
import { CharteGraphique } from "@/api/models/options/charteGraphique/charteGraphique";
//@ts-ignore
import { $themeColors } from "@themeConfig";
import { TypeGraphEnum } from "@/api/models/enums/typeGraph";
import { RapportActiviteConfig } from "@/api/models/rapportActivites/rapportActiviteTemplate";
@Component({
  components: {
    SearchableVueSelect,
    BButton,
    RessifApexPieChart,
  },
  name: "douleur-psychique-consultations-mdt-chart",
})
export default class DouleurPsychiqueConsultationsMDTChart extends Vue {
  @Prop({ required: true }) charteGraphique!: CharteGraphique;
  @Prop({ required: true }) model!: any;
  @Prop({ required: true }) reference!: any;
  title = "Accompagnement individuel - Visites sous délégation MDT";
  description = "(044) Répartition par douleur psychique des consultations sous délégation MDT";
  tableFields = [
    { key: "douleurPsychique", label: "Tranche de Temps", type: "text", editable: true },
    { key: "nombrePI", label: "Nombre de PI", type: "number", editable: true },
    { key: "actions", label: "Actions", editable: false },
  ];
  sampleDatas = [
    {
      id: 1,
      douleurPsychique: "Douleur psychique 1",
      nombrePI: 35,
    },
    {
      id: 2,
      douleurPsychique: "Douleur psychique 2",
      nombrePI: 55,
    },
    {
      id: 3,
      douleurPsychique: "Douleur psychique 3",
      nombrePI: 25,
    },
    {
      id: 4,
      douleurPsychique: "Douleur psychique 4",
      nombrePI: 5,
    },
  ];
  addLinePayload = {
    douleurPsychique: "Autre",
    nombrePI: 0,
  };
  seriesArr: any[] | null = null;
  categoriesArr: any[] | null = null;
  typeGraph = TypeGraphEnum.Individuel;
  modelCopy: any | null = null;
  created() {
    this.modelCopy = JSON.parse(JSON.stringify(this.model));
  }
  onRowDeleted(payload: any) {
    this.sampleDatas = this.sampleDatas.filter((x) => x.id !== payload.id);
    // Nécessaire car editable-table demande un délai pour l'update
    setTimeout(() => {
      let dataArray = this.sampleDatas.map((x: any) => parseInt(x.nombrePI));
      let seriesArray = this.sampleDatas.map((x: any) => x.douleurPsychique ?? "");
      this.seriesArr = dataArray;
      this.categoriesArr = seriesArray as any[];
      (this.$refs[payload.graphRef] as any).$refs[
        payload.graphRef
      ].updateOptions(
        {
          labels: this.categoriesArr,
        },
        false,
        true,
        true,
      );
    }, 200);
  }
  onRowAdded(payload: any) {
    this.sampleDatas = payload.values;
    setTimeout(() => {
      let dataArray = this.sampleDatas.map((x: any) => parseInt(x.nombrePI));
      let seriesArray = this.sampleDatas.map((x: any) => x.douleurPsychique ?? "");
      this.seriesArr = dataArray;
      this.categoriesArr = seriesArray as any[];
      (this.$refs[payload.graphRef] as any).$refs[
        payload.graphRef
      ]?.updateOptions(
        {
          labels: this.categoriesArr,
        },
        false,
        true,
        true,
      );
    }, 200);
  }
  async loadData(
    graphRef: any,
    config?: RapportActiviteConfig,
  ) {
    this.modelCopy.maxCategoryNumber = config?.maxCategoryNumber;
    this.modelCopy.otherLibelle = config?.otherLibelle;
    await this.$http.ressifnet.rapportActivites
      .repartitionDouleurPsychiqueConsultationsMDT(this.modelCopy)
      .then((response: any) => {
        let dataArray = response.map((x: any) => parseInt(x.nombrePI));
        let seriesArray = response.map((x: any) => x.douleurPsychique ?? "");
        this.seriesArr = dataArray;
        this.categoriesArr = seriesArray as any[];
        this.sampleDatas = response.map((x: any) => {
          return {
            id: x.id,
            douleurPsychique: x.douleurPsychique,
            nombrePI: x.nombrePI,
          };
        });
        (this.$refs[graphRef] as any).$refs[graphRef]?.updateOptions(
          {
            labels: this.categoriesArr,
          },
          false,
          true,
          true,
        );
        (this.$refs[graphRef] as any).$refs[graphRef].chart
          .render()
          .then(() => {
            (this.$refs[this.reference] as any).loading = false;
            (this.$refs[this.reference] as any).locked = false;
          });
      })
      .catch((e: any) => {
        (this.$refs[graphRef] as any).loading = false;
        (this.$refs[graphRef] as any).locked = true;
        (this.$refs[graphRef] as any).disabledButtonTrueData = false;
        let message = e.response?.data?.errors
          ? `Un problème est survenu lors du chargement du graphique: ${
              Object.values(e.response.data.errors)[0]
            }`
          : `Un problème est survenu lors du chargement du graphique ${this.constructor.name}`;
        console.error(e);
        this.$swal({
          title: "Erreur",
          text: message,
          icon: "error",
          customClass: {
            confirmButton: "btn btn-danger",
          },
          buttonsStyling: false,
        });
      });
  }
  async loadTrueData(graphRef: any, config?: RapportActiviteConfig) {
    await this.loadData(graphRef, config);
  }
  toggleExportToList(graphRef: any) {
    this.$emit("toggle-export-to-list", graphRef);
  }
  baseConfig = {
    series: [35, 35, 25, 5],
    chartOptions: {
      labels: ["Douleur psychique 1", "Douleur psychique 2", "Douleur psychique 3", "Douleur psychique 4"],
      dataLabels: {
        style: {
          fontSize: "17px",
        },
      },
      legend: {
        position: "bottom",
        fontSize: "17px",
        width: 550,
        offsetX: 50,
        formatter: function (val: any, opts: any) {
          let selected = opts.w.config.series[opts.seriesIndex];
          return opts.w.config.labels[opts.seriesIndex] + " (" + selected + ")";
        },
      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val;
          },
        },
      },
    },
  };
}
